module.exports = __webpack_public_path__ + "media/images/products/products/v3-5b42491642f336daf33ac6149c380e51.jpg";